import { SectionTitle } from "../UI";

export function TwoCol({ children }) {
  return (
    <div className="responsive-two-col">
      {children}
    </div>
  );
}

export function SubSection({ title, color, children }) {
  const hasContent = Array.isArray(children)
    ? children.some(Boolean)
    : Boolean(children);
  if (!hasContent) return null;
  return (
    <div>
      <SectionTitle color={color}>{title}</SectionTitle>
      {children}
    </div>
  );
}

export function TrackPerformanceDisplay({ data, color }) {
  if (!data) return null;

  const rowStyle = { display: "flex", justifyContent: "space-between", fontSize: 11, borderBottom: "1px solid #e2e8f0", padding: "4px 0" };
  const labelStyle = { color: "#64748b" };
  const valStyle = { fontWeight: 600, color: "#0f172a" };

  const fmt = (v) => (v != null && !isNaN(v)) ? `${Number(v).toFixed(2)}%` : "—";
  const fmtNum = (v) => (v != null && !isNaN(v)) ? Number(v).toFixed(2) : "—";

  const totalAssets = data.TOTAL_ASSETS || 1;
  const getExpPct = (val) => {
    if (val == null || isNaN(val)) return "—";
    if (val > 100) return `${((val / totalAssets) * 100).toFixed(2)}%`;
    return `${Number(val).toFixed(2)}%`;
  };

  return (
    <div style={{ marginTop: 12, padding: "12px 14px", background: "white", borderRadius: 10, border: `1px solid ${color}40`, boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <div style={{ fontSize: 10, fontWeight: 800, color, textTransform: "uppercase", letterSpacing: 0.5 }}>
          📊 נתוני ביצועים וסיכון (API ממשלתי)
        </div>
        <div style={{ fontSize: 9, color: "#94a3b8" }}>עדכון: {data.REPORT_PERIOD}</div>
      </div>

      <div className="responsive-two-col" style={{ gap: "0 20px" }}>
        <div>
          <div style={{ ...rowStyle, borderTop: "none" }}><span style={labelStyle}>תשואה חודשית</span> <span style={valStyle}>{fmt(data.MONTHLY_YIELD)}</span></div>
          <div style={rowStyle}><span style={labelStyle}>תשואה מתחילת שנה</span> <span style={valStyle}>{fmt(data.YEAR_TO_DATE_YIELD)}</span></div>
          <div style={rowStyle}><span style={labelStyle}>תשואה 3 שנים</span> <span style={valStyle}>{fmt(data.YIELD_TRAILING_3_YRS)}</span></div>
          <div style={rowStyle}><span style={labelStyle}>תשואה 5 שנים</span> <span style={valStyle}>{fmt(data.YIELD_TRAILING_5_YRS)}</span></div>
          <div style={rowStyle}><span style={labelStyle}>ממוצע שנתי (3ש')</span> <span style={valStyle}>{fmt(data.AVG_ANNUAL_YIELD_TRAILING_3YRS)}</span></div>
        </div>
        <div>
          <div style={{ ...rowStyle, borderTop: "none" }}><span style={labelStyle}>סטיית תקן</span> <span style={valStyle}>{fmtNum(data.STANDARD_DEVIATION)}</span></div>
          <div style={rowStyle}><span style={labelStyle}>מדד שארפ</span> <span style={valStyle}>{fmtNum(data.SHARPE_RATIO)}</span></div>
          <div style={rowStyle}><span style={labelStyle}>אלפא</span> <span style={valStyle}>{fmtNum(data.ALPHA)}</span></div>
          <div style={rowStyle}><span style={labelStyle}>חשיפה למניות</span> <span style={valStyle}>{getExpPct(data.STOCK_MARKET_EXPOSURE)}</span></div>
          <div style={rowStyle}><span style={labelStyle}>חשיפה לחו"ל</span> <span style={valStyle}>{getExpPct(data.FOREIGN_EXPOSURE)}</span></div>
          {data.FOREIGN_CURRENCY_EXPOSURE != null && (
            <div style={rowStyle}><span style={labelStyle}>חשיפה למט"ח</span> <span style={valStyle}>{getExpPct(data.FOREIGN_CURRENCY_EXPOSURE)}</span></div>
          )}
        </div>
      </div>

    </div>
  );
}
